<template>
  <div class="get-quote-parent">
    <span class="get-quote-header">
      <p class="get-quote-header-data">Please fill the details below!</p>
      <p style="font-size: 22px;">&#10005;</p>
    </span>
    <span class="get-quote-inputarea">
      <p>Name</p>
      <input v-model="name" ref="name" />
      <p>Mobile</p>
      <input v-model="mobile" ref="mobile" />
      <p>Email</p>
      <input v-model="email" ref="email" />
      <p>Requirement</p>
      <textarea v-model="req" ref="req" />
    </span>
    <span class="get-quote-send-button" @click="sendQuoteRequest">
      <p>SEND</p>
    </span>
  </div>
</template>
<script>
import { db } from "../main";

export default {
  data() {
    return {
      name: "",
      mobile: "",
      email: "",
      req: ""
    };
  },
  methods: {
    sendQuoteRequest() {
      if (
        (/^[a-zA-Z\s]+$/.test(this.name) &&
          /.+@.+/.test(this.email) &&
          this.req.length > 0) ||
        (/^[a-zA-Z\s]+$/.test(this.name) &&
          this.mobile.length == 10 &&
          /^[0-9]+$/.test(this.mobile) &&
          this.req.length > 0)
      ) {
        db.collection("quotations")
          .add({
            name: this.name,
            mobile: this.mobile,
            email: this.email,
            req: this.req
          })
          .then(() => {
            fetch(
              "https://us-central1-ioggly.cloudfunctions.net/ewlcm?name=" +
                this.name +
                "&mobile=" +
                this.mobile +
                "&email=" +
                this.email +
                "&req=" +
                this.req
            )
              .then(response => response.json())
              .then(data => {
                console.log(data); // Prints result from `response.json()` in getRequest
              })
              .catch(error => console.error(error));
            console.log("done");
          })
          .catch(err => {
            console.log(err);
          });
      } else {
        if (/^[a-zA-Z\s]+$/.test(this.name) || this.name.length == 0) {
          this.$refs.name.style.border = "solid 1.5px red";
          this.$refs.name.placeholder = "Enter Name Correct Name";
        }
        if (this.req.length == 0) {
          this.$refs.req.style.border = "solid 1.5px red";
          this.$refs.req.placeholder = "Enter Your Requirement";
        }
      }
      // console.log(this.$data);
    }
  }
};
</script>
<style scoped>
p {
  margin: 0 !important;
}
input {
  width: 100%;
  height: 30px;
  border-radius: 5px;
  border: solid 1px #ced4da;
  background-color: #ffffff;
  margin: 8px 0px;
  padding: 0 5px;
}
textarea {
  width: 100%;
  border-radius: 5px;
  border: solid 1px #ced4da;
  background-color: #ffffff;
  margin: 8px 0px;
  padding: 5px 5px;
}
input:focus {
  border: solid 1px rgb(68, 21, 229);
}
textarea:focus {
  border: solid 1px rgb(68, 21, 229);
}
.get-quote-send-button {
  font-size: 16px;
  font-weight: 600;
  text-align: right;
  color: rgb(68, 21, 229);
  padding: 0px 20px 20px 0;
}
.get-quote-inputarea {
  padding: 21px 20px;
}
.get-quote-parent {
  display: flex;
  flex-direction: column;
  background: white;
  width: 360px;
  height: max-content;
  position: fixed;
  right: 21px;
  bottom: 95px;
  z-index: 1000;
  border-radius: 10px;
}
.get-quote-header {
  background-color: #4415e5;
  border-radius: 10px;
  color: white;
  display: flex;
  justify-content: space-between;
  padding: 20px 15px;
  align-items: center;
}
.get-quote-header-data {
  font-size: 16px;
  font-weight: 600;
  text-align: left;
}
</style>
